import styles from './myImage.module.css';

type MyImageProps = {
  src: string;
  description: string;
  name?: string;
  compact?: boolean;
  onClick?: () => void;
  fullImageSrc?: string;
};

export const MyImage: React.FC<MyImageProps> = ({ src, name, description, compact = false, onClick }) => {
  return (
    <div className={styles.myImageContainer}>
      <div
        className={styles.myImage}
        style={{
          height: compact ? 150 : 250,
          width: compact ? 150 : 250,
        }}
      >
        <img
          src={src}
          alt={description}
          title={description}
          onClick={onClick}
          onKeyUp={(e) => {
            if (e.key === 'Enter' || e.key === ' ') {
              onClick?.();
            }
          }}
          style={{ maxWidth: '100%' }}
        />
      </div>
      <p style={{ marginTop: '0.5rem' }}>{description === name ? name : description}</p>
    </div>
  );
};

export type ClickedImageType = {
  src?: string;
  uncompressedImageSrc?: string;
  description: string;
  name?: string;
  index?: number;
};
